import { promiseWithTimeout } from './promiseWithTimeout.js';

/** Tiempo máximo habitual para lecturas Supabase en cliente (evita «Cargando…» infinito). */
export const DEFAULT_APP_FETCH_MS = 20000;

/** Tiempo máximo para hidratar sesión al arrancar / refrescar la SPA. */
export const AUTH_INIT_MS = 12000;

export const APP_FETCH_TIMEOUT_MESSAGE =
  'La carga tardó demasiado. Comprueba la conexión o pulsa Reintentar.';

/**
 * Ejecuta una promesa de datos con tope de tiempo.
 * @template T
 * @param {() => Promise<T>} factory
 * @param {{ timeoutMs?: number, timeoutMessage?: string }} [opts]
 * @returns {Promise<T>}
 */
export async function runAppDataFetch(factory, opts = {}) {
  const timeoutMs = opts.timeoutMs ?? DEFAULT_APP_FETCH_MS;
  const timeoutMessage = opts.timeoutMessage ?? APP_FETCH_TIMEOUT_MESSAGE;
  return promiseWithTimeout(Promise.resolve().then(factory), timeoutMs, timeoutMessage);
}
